// // src/components/projects/ProjectCard/ProjectCard.jsx
// import React from "react";
// import {
//   FiMapPin,
//   FiArrowUpRight,
//   FiTrendingUp,
//   FiLayers,
// } from "react-icons/fi";
// import converPrice from "../../utils/convertAmount";
// import "./ProjectCard.css";
// import apis from "../../utils/apis";
// import httpAction from "../../utils/httpAction";
// import { useNavigate } from "react-router-dom";

// export default function ProjectCard({ item,loading }) {
//   const navigate = useNavigate();
//   const addVisit = async () => {
//     const data = {
//       url: apis().lisitingAddVisit + "?id=" + item?._id,
//       method: "PUT",
//     };
//     await httpAction(data);
//   };
//   return (
//     <article className="pjc">
//       <div className="pjc__media">
//         <img
//           className="pjc__img"
//           src={apis().localUrl + item?.data?.images[0].url}
//           alt={item?.data?.title}
//         />
//         <div className="pjc__top">
//           <span
//             className={`pjc__badge pjc__badge--${item?.data?.construction}`}
//           >
//             {item?.data?.construction}
//           </span>
//           {/* {item.tag ? (
//             <span className="pjc__tag">
//               <FiTrendingUp /> {item.tag}
//             </span>
//           ) : null} */}
//         </div>
//       </div>

//       <div className="pjc__body">
//         <h3 className="pjc__title">{item?.data?.title}</h3>

//         <div className="pjc__loc">
//           <FiMapPin />
//           <span>{item?.data?.location}</span>
//         </div>

//         <div className="pjc__meta">
//           <span className="pjc__metaItem">
//             <FiLayers /> {item?.data?.towers} Towers
//           </span>
//           <span className="pjc__metaItem">{item?.data?.units}+ Units</span>
//           {/* <span className="pjc__metaItem">{item.height}</span> */}
//         </div>

//         <div className="pjc__footer">
//           <div className="pjc__price">
//             <span className="pjc__priceLabel">Starting</span>
//             <span className="pjc__priceVal">
//               {converPrice(item?.data?.price)}/SQ.FT
//             </span>
//           </div>

//           <button
//             onClick={() => {
//               addVisit();
//               navigate("/project/detail?id=" + item?._id);

//               window.scroll({ top: 0, behavior: "smooth" });
//             }}
//             className="pjc__btn"
//             type="button"
//           >
//             View Project <FiArrowUpRight />
//           </button>
//         </div>
//       </div>
//     </article>
//   );
// }


import React from "react";
import {
  FiMapPin,
  FiArrowUpRight,
  FiLayers,
} from "react-icons/fi";
import converPrice from "../../utils/convertAmount";
import "./ProjectCard.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import { useNavigate } from "react-router-dom";

// ✅ MUI
import { Skeleton } from "@mui/material";

export default function ProjectCard({ item, loading = false }) {
  const navigate = useNavigate();

  const addVisit = async () => {
    const data = {
      url: apis().lisitingAddVisit + "?id=" + item?._id,
      method: "PUT",
    };
    await httpAction(data);
  };

  const isLoading =
    loading ||
    !item ||
    !item?.data ||
    !item?.data?.title ||
    !item?.data?.images?.length;

  // ✅ Skeleton view
  if (isLoading) {
    return (
      <article className="pjc">
        <div className="pjc__media">
          <Skeleton variant="rectangular" width="100%" height={220} />
          <div className="pjc__top" style={{ marginTop: 10 }}>
            <Skeleton variant="rounded" width={110} height={26} />
          </div>
        </div>

        <div className="pjc__body">
          <Skeleton variant="text" width="80%" height={32} />

          <div className="pjc__loc" style={{ marginTop: 6 }}>
            <Skeleton variant="text" width="60%" height={22} />
          </div>

          <div
            className="pjc__meta"
            style={{ marginTop: 10, display: "flex", gap: 10 }}
          >
            <Skeleton variant="rounded" width={120} height={26} />
            <Skeleton variant="rounded" width={90} height={26} />
          </div>

          <div className="pjc__footer" style={{ marginTop: 14 }}>
            <div className="pjc__price">
              <Skeleton variant="text" width={70} height={18} />
              <Skeleton variant="text" width={120} height={26} />
            </div>

            <Skeleton variant="rounded" width={150} height={40} />
          </div>
        </div>
      </article>
    );
  }

  // ✅ Original view
  return (
    <article className="pjc">
      <div className="pjc__media">
        <img
          className="pjc__img"
          src={apis().localUrl + item?.data?.images?.[0]?.url}
          alt={item?.data?.title}
        />
        <div className="pjc__top">
          <span className={`pjc__badge pjc__badge--${item?.data?.construction}`}>
            {item?.data?.construction}
          </span>
        </div>
      </div>

      <div className="pjc__body">
        <h3 className="pjc__title">{item?.data?.title}</h3>

        <div className="pjc__loc">
          <FiMapPin />
          <span>{item?.data?.location}</span>
        </div>

        <div className="pjc__meta">
          <span className="pjc__metaItem">
            <FiLayers /> {item?.data?.towers} Towers
          </span>
          <span className="pjc__metaItem">{item?.data?.units}+ Units</span>
        </div>

        <div className="pjc__footer">
          <div className="pjc__price">
            <span className="pjc__priceLabel">Starting</span>
            <span className="pjc__priceVal">
              {converPrice(item?.data?.price)}/SQ.FT
            </span>
          </div>

          <button
            onClick={() => {
              addVisit();
              navigate("/project/detail?id=" + item?._id);
              window.scroll({ top: 0, behavior: "smooth" });
            }}
            className="pjc__btn"
            type="button"
          >
            View Project <FiArrowUpRight />
          </button>
        </div>
      </div>
    </article>
  );
}